import { useNavigate } from "react-router-dom";

import KeyIcon from "@mui/icons-material/Key";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import useTheme from "@mui/material/styles/useTheme";

import Dialog from "components/dialog";

interface PasswordResetConfirmationProps {
  open: boolean;
  onClose: () => void;
}

export default function PasswordResetConfirmation({
  open,
  onClose
}: PasswordResetConfirmationProps) {
  const theme = useTheme();
  const navigate = useNavigate();

  return (
    <Dialog open={open} onClose={onClose}>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center"
        }}
      >
        <Box sx={{ fontSize: 80 }}>
          <KeyIcon
            sx={{ color: theme.palette.sideMenu.main }}
            fontSize="inherit"
          />
        </Box>
        <Typography
          sx={{ mt: 2 }}
          variant="h3"
          fontWeight="fontWeightBold"
          component="div"
        >
          Password Changed!
        </Typography>
        <Typography sx={{ mt: 5, lineHeight: "30px" }} variant="body2">
          Your password has been successfully changed
        </Typography>
        <Button
          sx={{
            mt: 5
          }}
          size="large"
          variant="contained"
          onClick={() => navigate("/login")}
        >
          Done
        </Button>
      </Box>
    </Dialog>
  );
}
